import { useState } from 'react';

import type { SelectionButtonsValueParams } from '@components/SelectionButtons';
import { translate } from '@chaika/i18n/helper';
import { store } from '@store';

interface UseSelectionButtonsData {
    activeTab: EditEntryDataTab;
    tabItems: SelectionButtonsValueParams[];
    setTab(value: EditEntryDataTab): void;
}

export enum EditEntryDataTab {
    Date = 'date',
    EntryData = 'entryData',
    CoAuthors = 'coAuthors',
}

export function useSelectionButtons(): UseSelectionButtonsData {
    const { authUser } = store;
    const [activeTab, setActiveTab] = useState<EditEntryDataTab>(EditEntryDataTab.EntryData);

    const tabItems: SelectionButtonsValueParams[] = [
        {
            value: EditEntryDataTab.EntryData,
            label: translate('entryOptions'),
        },
    ];

    if (authUser.hasRootAccess) {
        tabItems.push(
            {
                value: EditEntryDataTab.Date,
                label: translate('date'),
            },
            {
                value: EditEntryDataTab.CoAuthors,
                label: translate('coAuthors'),
            },
        );
    }

    function setTab(value: EditEntryDataTab) {
        setActiveTab(value);
    }

    return {
        activeTab,
        tabItems,
        setTab,
    };
}
